// Mints a unique session key for an assistant-authored draft project.
// Shape: `draft-project-<epoch-ms>-<8-char-base36-suffix>`.
//
// Extracted verbatim from App.jsx (TS-060 / DEC-COUNCIL-015 T1). Behaviour is
// unchanged; App.jsx re-imports this symbol.

export function createAssistantDraftSessionKey(): string {
    const suffix = Math.random().toString(36).slice(2, 10);
    return `draft-project-${Date.now()}-${suffix}`;
}

// ─── Draft became a job (spec 2026-10-07 section 5.3, F09) ──────────────────
// An unsaved quote's Assistant chat is carried into a job only when the save
// path says THIS draft became THAT job: a first save that minted the job, or
// the duplicate guard's "Reuse existing" that saved the draft into it. Opening
// any other job never adopts the draft chat.
//
// The save path does not know the Assistant's draft key, so it reports the job
// id with a sequence number. The panel notes the sequence when its draft chat
// starts and accepts only a report made after that, once.

let adoptionSeq = 0;
const adoptions = new Map<string, number>();

/** The save path: the draft open in this tab was saved as `projectId`. */
export function reportAssistantDraftBecameProject(projectId: string): void {
    if (!projectId) return;
    adoptionSeq += 1;
    adoptions.set(String(projectId), adoptionSeq);
}

/** The panel: a marker taken when a draft chat starts. */
export function assistantDraftAdoptionMark(): number {
    return adoptionSeq;
}

/**
 * The panel: true once when the save path reported, after `sinceMark`, that
 * the draft became `projectId`.
 */
export function consumeAssistantDraftAdoption(projectId: string | null | undefined, sinceMark: number): boolean {
    if (!projectId) return false;
    const seq = adoptions.get(String(projectId));
    if (seq === undefined || seq <= sinceMark) return false;
    adoptions.delete(String(projectId));
    return true;
}
